import { Risk } from '@src/types';

export const getAdditionalRiskCodesToString = (
  risks: Risk[] | undefined
): string => {
  if (!!risks?.length) {
    return risks
      .filter((item) => item.active && !item.binding)
      .map((item) => item.code)
      .join(', ');
  }

  return '';
};
